<div
    class="text-s text-med flex items-center gap-5"
    [matMenuTriggerFor]="rangeFilterMenu">
    <mat-icon svgIcon="module-settings" />
    {{ filterText }}
</div>
<mat-menu
    #rangeFilterMenu="matMenu"
    xPosition="before"
    yPosition="below"
    [overlapTrigger]="true">
    <div wfeStopClick class="wrapper overflow-hidden">
        <div class="text-sm p-2 pl-4">{{ params.title ?? 'Filter' }}</div>
        <mat-divider />
        <form *ngIf="form" class="p-5 pb-2 text-s" [formGroup]="form">
            <div class="flex items-center gap-5 mb-2">
                <app-input
                    class="flex-1"
                    variant="secondary"
                    type="number"
                    [placeholder]="minPlaceholder"
                    [min]="availableRange.min"
                    [max]="form.value.max"
                    formControlName="min" />
                {{ params.inputLabel ?? '' }}
                <span class="ml-1 mr-1">-</span>
                <app-input
                    class="flex-1"
                    variant="secondary"
                    type="number"
                    [placeholder]="maxPlaceholder"
                    [min]="form.value.min"
                    [max]="availableRange.max"
                    formControlName="max" />
                {{ params.inputLabel ?? '' }}
            </div>
            <app-range-slider
                *ngIf="form"
                [min]="availableRange.min"
                [max]="availableRange.max"
                [formGroup]="form"
                [minControlName]="'min'"
                [maxControlName]="'max'" />
        </form>
        <mat-divider />
        <div class="footer flex justify-space-between p-2 pr-6">
            <app-text-button [disabled]="!currentValue" (clicked)="reset()">
                Reset filter
            </app-text-button>
            <div class="flex gap-10 items-center">
                <app-flat-button (clicked)="close()">Cancel</app-flat-button>
                <app-flat-button variant="cta" (clicked)="apply()">
                    Apply
                </app-flat-button>
            </div>
        </div>
    </div>
</mat-menu>
